var BaseViews = require('../base');
var VideoPlayer = require('../video-player');
require('./video-expanded-modal/video-expanded-modal.scss');
var VideoExpandedModal = BaseViews.LayoutView.extend({
    className: 'fmcy-video-expanded-modal',
    template: require('./video-expanded-modal/video-expanded-modal.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'dark',
                collection: null,
                closeAtEndOfVideo: true
            }
        );
    },
    ui: {
      btnClose: '.fmcy-menu-item-btn-close'
    },
    triggers: {
      'click @ui.btnClose': 'close:clicked'
    },
    regions: {
        videoRegion: '.fmcy-video-region',
    },
    _onPopState: function (event) {
      this.trigger('close:clicked');
    },
    _onWindowKeyUp: function (event) {
      if (event.keyCode == 27) {
        this.trigger('close:clicked');
      }
    },
    _renderVideo: function () {
      var self = this;
      this._videoPlayer = new VideoPlayer({
        videoUrl: this.model.get('url'),
        width: '100%',
        size: 'scale'
      });
      this._videoPlayer.on('videoplayer:ended', function () {
        if (self.options.closeAtEndOfVideo) {
          self.trigger('close:clicked');
        }
      });
      this.videoRegion.show(this._videoPlayer);
    },
    _onWindowResize: function (event) {
      this._videoPlayer.setWidth($(window).outerWidth());
      this._videoPlayer.setHeight($(window).outerHeight());
    },
    onRender: function() {
      this._renderVideo();
      var self = this;
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
      $(window).on('keyup.' + this.cid, _.bind(this._onWindowKeyUp, this));
      $(window).on('popstate.' + this.cid, _.bind(this._onPopState, this));
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      $(window).off('keyup.' + this.cid);
      $(window).off('popstate.' + this.cid);
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    }
});

module.exports = VideoExpandedModal;



/** WEBPACK FOOTER **
 ** ./assets/js/common/video-group/video-expanded-modal.js
 **/